/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import web3 from "web3";
import { message, Steps, Checkbox, Modal, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Action from "./action";
import { useContract } from "../../hooks/useContract";
import abiStake from "./utils/abiStake.json"
import { isMobile } from "react-device-detect";
import { useHookStaked } from './storeStaked'
import { useAccount, useChainId } from "wagmi";
import { useParams } from "react-router-dom";
import { AbiItem } from "web3-utils";


const steps = [
    {
        title: '1',
        content: 'First-content',
    },
    {
        title: '2',
        content: '2-content',
    },
    {
        title: '3',
        content: '3-content',
    },
];

const provider = "https://public-bsc-mainnet.fastnode.io";
declare const window: Window & typeof globalThis & { ethereum: any };

const Withdraw = (props: any) => {
    const { poolContract } = useParams();
    const { address } = useAccount();
    const chainId = useChainId()
    let account = address
    const [state, actions] = useHookStaked()
    const contractStake: any = useContract(poolContract, abiStake);
    const [getUser, setGetUser] = useState<any>();
    const [bnbBalance, setBnbBalance] = useState(0);
    //const w3 = new web3(provider);
    const w3 = window.ethereum ? new web3(window.ethereum) : new web3(provider);
    const [showNext, setShowNext] = useState(false);
    const [isCheckTerm, setIsCheckTerm] = useState(false);
    const [current, setCurrent] = useState(0);
    const [timeUnstake, setTimeUnstake] = useState<any>();
    const [hashUnWr, setHashWr]: any = useState('');
    const [isSuccess, setIsSuccess]: any = useState(false)
    const [childData, setchildData]: any = useState(false)
    const [lockTimeUnstake, setlockTimeUnstake]: any = useState(0)
    const { Step } = Steps;

    // const lockTimeUnstake = 7 * 24 * 60 * 60 * 1000

    const formatNumber = (x: any, max: any) => {
        if (x) {
            return x.toLocaleString("en-US", {
                minimumFractionDigits: 1,
                maximumFractionDigits: max,
            });
        } else return 0;
    };

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const renderImg1 = () => {
        return (
            <img className="img-step-stake" src="/images/img/stake1.png" alt="" />
        )
    }
    const renderImg2 = () => {
        if (current < 1) {
            return <img className="img-step-stake" src="/images/img/unstake4.png" alt="" />
        } else {
            return <img className="img-step-stake" src="/images/img/unstake4-ac.png" alt="" />
        }
    }
    const renderImg5 = () => {
        if (current < 2) {
            return <img className="img-step-stake" src="/images/img/stake5.png" alt="" />
        } else {
            return <img className="img-step-stake" src="/images/img/stake5-ac.png" alt="" />
        }
    }

    const renderText1 = () => {
        return <span className="text-ac">Checkpoints</span>
    }
    const renderText2 = () => {
        if (current < 1) {
            return "Initialize Withdrawal"
        } else {
            return <span className="text-ac">Initialize Withdrawal</span>
        }
    }

    const renderText5 = () => {
        if (current < 4) {
            return "Confirmation"
        } else {
            return <span className="text-ac">Confirmation</span>
        }
    }

    const onChange = (e: any) => {
        setIsCheckTerm(e.target.checked)
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    useEffect(() => {
        if (account) {
            w3.eth.getBalance(account, (err, balance) => {
                if (balance) {
                    let _balance: any = web3.utils.fromWei(
                        web3.utils.toBN(balance),
                        "ether"
                    );
                    let bnbBl = Math.floor(parseFloat(_balance) * 100000) / 100000;
                    setBnbBalance(bnbBl);
                }
            });
        } else {
            setBnbBalance(0)
        }
    }, [account, chainId, current, childData]);

    const handleShowNext = () => {
        if (account && bnbBalance > 0 && isCheckTerm && getUser > 0 && ((timeUnstake * 1000 + lockTimeUnstake) <= date)) {
            setShowNext(true)
        } else {
            setShowNext(false)
        }
    }
    useEffect(() => {
        handleShowNext()
    }, [account, bnbBalance, current, isCheckTerm, current, getUser, childData])

    let date = Date.now();

    const getUserMap = async () => {
        if (contractStake) {
            const user = await contractStake.userMap(account);
            setTimeUnstake(Number(user.unstakeTime))
            setGetUser(user.inUnStakeAmount / 1e18);

        }
    };

    useEffect(() => {
        if (account) {
            getUserMap();
        } else {
            setTimeUnstake(0)
            setGetUser(0);
        }
    }, [account, current, childData, contractStake]);

    const handleWithdraw = async () => {
        try {
            setIsModalOpen(true);
            await contractStake.withdraw()
                .then(async (res: any) => {
                    const timestamp = new Date().getTime();
                    const date1 = new Date(timestamp);
                    let timeStake = date1.toLocaleString('en-GB')

                    let paramNoti = {
                        projectName: "BSCS",
                        amount: getUser,
                        actionType: 3,
                        userAddress: account,
                        tokenName: "BSCS",
                        actionTime: timeStake,
                        hash: res.hash,
                        status: "Waiting"
                    }
                    await actions.callNoti(paramNoti)

                    res.wait()
                        .then(async (resWait: any) => {
                            if (resWait?.status === 1) {
                                const timestamp = new Date().getTime();
                                const date1 = new Date(timestamp);
                                let timeStake = date1.toLocaleString('en-GB')

                                let paramNoti = {
                                    projectName: "BSCS",
                                    amount: getUser,
                                    actionType: 3,
                                    userAddress: account,
                                    tokenName: "BSCS",
                                    actionTime: timeStake,
                                    hash: resWait?.transactionHash,
                                    status: "Success"
                                }
                                await actions.callNoti(paramNoti)

                                setHashWr(resWait.transactionHash)
                                message.success({
                                    type: "success",
                                    content: "Withdraw successfully",
                                    className: "custom-class",
                                    duration: 3,
                                });
                                props.setIsCheckAction(!props.isCheckAction)
                                setIsSuccess(!isSuccess)
                                setIsModalOpen(false);
                                setCurrent(current + 1);
                                //--
                            } else {
                                message.error({
                                    type: "error",
                                    content: "Unknown error (status hash fail)",
                                    className: "custom-class",
                                    duration: 3,
                                });
                                setIsModalOpen(false);
                            }

                        })
                        .catch((err: any) => {
                            message.error({
                                type: "error",
                                content: "Unknown error",
                                className: "custom-class",
                                duration: 3,
                            });
                            setIsModalOpen(false);
                        })
                })
                .catch((err: any) => {
                    console.log('err', err)
                    let errMsg: any = err?.reason || err?.message || err?.code || 'Unknown error';
                    if (errMsg?.includes(': 0x0')) {
                        errMsg = errMsg.split(': 0x0')[0].trim();
                    } else if (errMsg?.includes('0x0')) {
                        errMsg = errMsg.split('0x0')[0].trim();
                    }
                    setIsModalOpen(false);
                    message.error({
                        type: "error",
                        content: errMsg,
                        className: "custom-class",
                        duration: 3,
                    });

                })
        } catch (error: any) {
            console.log('err catch-->', error)
            let errMsg: any = error?.reason || error?.message || error?.code || 'Unknown error';
            if (errMsg?.includes(': 0x0')) {
                errMsg = errMsg.split(': 0x0')[0].trim();
            } else if (errMsg?.includes('0x0')) {
                errMsg = errMsg.split('0x0')[0].trim();
            }
            message.error({
                type: "error",
                content: errMsg,
                className: "custom-class",
                duration: 3,
            });
            setIsModalOpen(false);

        }
    }

    const callbackFunction = (data: any) => {
        setchildData(data)
    };
    const onChangeAll = () => {

        setIsCheckTerm(!isCheckTerm)
    };

    const contractStake1 = new w3.eth.Contract(
        abiStake as unknown as AbiItem,
        poolContract
    );
    const getLockTimeUnstake = async () => {
        try {
            await contractStake1.methods.lockTimePeriod().call()
                .then((res: any) => {
                    setlockTimeUnstake(Number(res) * 1000)
                })
                .catch((err: any) => {
                    setlockTimeUnstake(0)
                });
        } catch (error) {
            //
        }
    };
    useEffect(() => {
        getLockTimeUnstake()
    }, [])

    function convertSecondsToDays(seconds: any) {
        return Math.floor(seconds / (60 * 60 * 24));
    }

    return (
        <div className="wrap-stake">
            <div className="stake">
                <div className="wrap-all">

                    <div className="stake-your-token">Stake your BSCS</div>
                    <div className="content-stake">

                        {/* @ts-ignore this lib is incompatible with react18  */}
                        <Steps current={current}>
                            <Step
                                title={renderText1()}
                                icon={renderImg1()}
                            />
                            <Step
                                title={renderText2()}
                                icon={renderImg2()}
                            />

                            <Step
                                title={renderText5()}
                                icon={renderImg5()}
                            />
                        </Steps>

                        {/* <div className="steps-content">{steps[current].content}</div> */}
                        {current === 0 ? (
                            <div className="content-step1">
                                <div className="title">Checkpoints</div>
                                <div className="des">The following conditions must be met to proceed:</div>
                                <div className="item-step1">
                                    <div className="card-item">
                                        <div className={`${account ? 'check-card acive' : 'check-card'}`}>
                                            <img src="/images/img/check-before.png" alt="" />
                                            <img src="/images/img/check-after.png" alt="" />

                                        </div>
                                        <div className="title-card">Connected with MetaMask</div>
                                        <div className="content-card">If not connected, click the "Connect Wallet" button in the top right corner</div>
                                    </div>
                                    <div className="card-item">
                                        <div className={`${(timeUnstake * 1000 + lockTimeUnstake) <= date && getUser > 0 ? 'check-card acive' : 'check-card'}`}>
                                            <img src="/images/img/check-before.png" alt="" />
                                            <img src="/images/img/check-after.png" alt="" />

                                        </div>
                                        <div className="title-card">{convertSecondsToDays(lockTimeUnstake / 1000)} day waiting period elapsed</div>
                                        {/* <div className="content-card">Current Balance: 0.0000</div> */}
                                    </div>
                                    <div className="card-item">
                                        <div className={`${bnbBalance > 0 ? 'check-card acive' : 'check-card'}`}>
                                            <img src="/images/img/check-before.png" alt="" />
                                            <img src="/images/img/check-after.png" alt="" />

                                        </div>
                                        <div className="title-card">BNB available in wallet</div>
                                        <div className="content-card">BNB is required to pay transaction fees on the BNB Smart Chain network.<br />BNB Balance: {formatNumber(bnbBalance, 4)}</div>
                                    </div>
                                    <div className="card-item">
                                        <div className={`${getUser > 0 ? 'check-card acive' : 'check-card'}`}>
                                            <img src="/images/img/check-before.png" alt="" />
                                            <img src="/images/img/check-after.png" alt="" />

                                        </div>
                                        <div className="title-card">You have Unstaked your BSCS</div>
                                        {/* <div className="content-card">You cannot stake if you have an active BSCS unstake/withdrawal request</div> */}
                                    </div>
                                </div>
                                <div className="check-real" onClick={onChangeAll}>
                                    <Checkbox checked={isCheckTerm} onChange={onChange} /> <span>I have read the <a target="_blank" href="/TermOfUse" className="terms">Terms and Conditions</a></span>
                                </div>
                            </div>
                        ) : (
                            <>
                                {current === 1 ? (
                                    <div className="content-step2">
                                        <div className="title">Confirm Withdrawal</div>
                                    </div>
                                ) : (
                                    <>
                                        {current === 2 ? (
                                            <div className="content-step5">
                                                <div className="title">Confirmation</div>
                                                <div className="des">Congratulations! Your tokens have withdrawn.</div>
                                                <div className="success-content">
                                                    <div className="img-success">
                                                        <img src="/images/img/stake-success.png" alt="" />
                                                    </div>
                                                    <div className="mid-content">Success</div>
                                                    <div className="mid-content1">Congratulations! Your tokens have withdrawn</div>
                                                    <div className="mid-content2">If desired, you may check BNB Smart Chain to confirm the transaction.</div>
                                                    {isMobile ? (
                                                        <a className="mid-content3" target="_blank" rel="noreferrer" href={`https://bscscan.com/tx/${hashUnWr}`}>
                                                            {hashUnWr.slice(0, 10)}...{hashUnWr.slice(-10)}
                                                        </a>
                                                    ) : (
                                                        <a className="mid-content3" target="_blank" rel="noreferrer" href={`https://bscscan.com/tx/${hashUnWr}`}>{hashUnWr}</a>
                                                    )}

                                                </div>
                                            </div>
                                        ) : (
                                            <>

                                                {/* {current === 3 ? (
                                                    <div className="content-step4">
                                                        <div className="title">Confirm</div>
                                                        <div className="des">Required transaction 2 of 2</div>
                                                        <div className="confirm-content">
                                                            <div className="cf-content1">In this step, you deposit the tokens into the staking contract.</div>
                                                            <div className="cf-content1">After this step, your tokens will be successfully staked.</div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {current === 4 ? (
                                                            <div className="content-step5">
                                                                <div className="title">Confirmation</div>
                                                                <div className="des">Congratulations! Your tokens are now staked.</div>
                                                                <div className="success-content">
                                                                    <div className="img-success">
                                                                        <img src="/images/img/stake-success.png" alt="" />
                                                                    </div>
                                                                    <div className="mid-content">Success</div>
                                                                    <div className="mid-content1">Congratulations! Your tokens are now staked.</div>
                                                                    <div className="mid-content2">If desired, you may check BNB Smart Chain to confirm the transaction.</div>
                                                                    <a className="mid-content3" href="#">0x6db5d43a31599de3eb6804b64b9f6c2be670d52f02e1cf70248f720a1649fe5c</a>
                                                                </div>
                                                            </div>
                                                        ) : ('')}
                                                    </>
                                                )} */}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </div>

                </div>
                <Action isSuccess={isSuccess} tabBox={props.tabBox} parentCallback={callbackFunction} />

            </div>
            <div className="steps-action">

                {current > 0 && current !== steps.length - 1 && (
                    <button className="btn-control" onClick={() => prev()}> Previous</button>
                )}
                {current < steps.length - 1 && (
                    <>
                        {showNext ? (
                            <>
                                {current === 1 ?
                                    <>
                                        <button className="btn-control" onClick={handleWithdraw}> Next</button>
                                    </>
                                    :
                                    <>
                                        <button className="btn-control" onClick={() => next()}> Next</button>
                                    </>
                                }
                            </>
                        ) : (
                            <button className="btn-control dis"> Next</button>
                        )}
                    </>

                )}
                {current === steps.length - 1 && (
                    <button className="btn-control" onClick={() => window.location.reload()}> Done</button>
                )}

            </div>

            {/* @ts-ignore this lib is incompatible with react18  */}
            <Modal
                title="Withdrawal"
                visible={isModalOpen}
                footer={false}
                wrapClassName="modal-confirm"
            >
                <p className="modal-text1">Your request is being processed. Please wait...</p>
                <p className="spin-stake">
                    <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 55 }} spin />} />
                </p>

            </Modal>
        </div>


    )
}

export default Withdraw;